import {findClosestReservation} from "@/utils";

const state = {
	actionParam: null,
	reservationIdParam: null,
	toast: {
		showToast: false,
		toastMessage: "",
		idToast: ""
	},
	// Event confirmation status from query params
	eventConfirmationStatus: null, // 'confirmed', 'already_confirmed', 'already_attended'
	// Event welcome data received via WebSocket after host scans QR
	eventWelcome: null, // { eventName, sessionName, userName, registrationType }
};

const getters = {
	actionParam(state) {
		return state.actionParam;
	},
	reservationIdParam(state) {
		return state.reservationIdParam;
	},
	toast: state => {
		return state.toast;
	},
	eventConfirmationStatus(state) {
		return state.eventConfirmationStatus;
	},
	eventWelcome(state) {
		return state.eventWelcome;
	},
};

const mutations = {

	setToast(state, payload) {
		state.toast = payload.toast;
	},

	setEventWelcome(state, welcomeData) {
		state.eventWelcome = welcomeData;
	},

	clearEventWelcome(state) {
		state.eventWelcome = null;
	},
};

const actions = {
	loadQueryParamsToState({rootGetters }) {
		const queryParams = new URLSearchParams(window.location.search);
		state.actionParam = queryParams.get('action');

		switch (state.actionParam) {
			case "1":{
				state.reservationIdParam = queryParams.get('id');
				break;
			}
			case "2":{
				const dateParam = queryParams.get('date');
				const timeParam = queryParams.get('time');
				const startDateTime = new Date(`${dateParam} ${timeParam}`);
				const userReservations = rootGetters['user/userReservations'];
				state.reservationIdParam = findClosestReservation(userReservations, startDateTime);
				break;
			}
			default:{
				break;
			}
		}

		// Handle event confirmation query params
		if (queryParams.get('confirmed') === '1') {
			state.eventConfirmationStatus = 'confirmed';
		} else if (queryParams.get('already_confirmed') === '1') {
			state.eventConfirmationStatus = 'already_confirmed';
		} else if (queryParams.get('already_attended') === '1') {
			state.eventConfirmationStatus = 'already_attended';
		} else {
			state.eventConfirmationStatus = null;
		}
	},
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
